import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { setUpErrorHandling } from '@bingads-webui-campaign/summary-grid-helper';

import { NegativeKeywordListGrid } from './negative-keyword-list-grid';
import { getConfig } from './grid-config';
import { getPlugins } from './plugins';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/keywords-tab');

export function createNegativeKeywordsListsGrid({
  dataSource,
  filterService,
  getAdditionalPlugins = () => [],
  preferenceConfig,
  router,
  scope,
  addDateChangeListener,
  p$daterange,
  isForVNext = false,
  perfMarker,
  viewport,
}) {
  return new NegativeKeywordListGrid({
    isForVNext,
    filterService,
    i18n,
    getGridConfig: view => getConfig({
      dataSource,
      scope,
      view,
      filterService,
      preferenceConfig,
      router,
      isForVNext,
      viewport,
    }),
    getPlugins: view => getPlugins({
      filterService,
      router,
      scope,
      isForVNext,
      addDateChangeListener,
      perfMarker,
      p$daterange,
    }).concat(getAdditionalPlugins(view)),
    router,
    scope,
    setupDataSourceErrorHandling: view => setUpErrorHandling({
      gridView: view,
      scope,
      dataSource,
      i18n,
    }),
    preferenceConfig,
  });
}

export { CreateNegativeKeywordAssocationView } from './create-association/create-association-view';
